import { useAnalytics } from 'telia-front-react';
import { Offer } from './OfferInterfaces';

const OfferViewAsAnalyticsHook = (props: { offer: Offer; isShopOffer: boolean }): JSX.Element => {
  const { push } = useAnalytics();
  if (!props.offer.displayed && !props.isShopOffer) {
    push(`Show - ${props.offer.slug}`);
    props.offer.displayed = true;
  }
  return null;
};
export default OfferViewAsAnalyticsHook;
